import React, {ReactElement} from 'react';
import LayoutSection from '../Layout/LayoutSection/LayoutSection';
import {LayoutBackground} from '../Layout/LayoutSection/LayoutSection.types';
import SearchBar from '../Fields/SearchBar/SearchBar';
import TagsButtons, {TagProps} from '../TagsButtons/TagsButtons';
import hubHeroCircles from './circlesConfig';
import Headers, {HeaderType} from '../Text/Headers/Headers';
import Paragraph from '../Text/Paragraph/Paragraph';
import {Alignment} from '../../../types';

import './HubHero.scss';

interface HubHeroProps {
  title: string;
  description: string;
  searchBarPlaceholder?: string;
  handleSearch?: (value: string) => void;
  tags?: TagProps[];
  selectedTag?: string;
}

function HubHero({
  title,
  description,
  handleSearch,
  searchBarPlaceholder,
  tags,
  selectedTag,
}: HubHeroProps): ReactElement {
  return (
    <LayoutSection innerClassName="hubHero" type={LayoutBackground.WHITE} circles={hubHeroCircles}>
      <div className="hubHero__contents">
        <Headers className="hubHero__contents__title" headerType={HeaderType.H1} alignment={Alignment.CENTER}>
          {title}
        </Headers>
        <Paragraph className="hubHero__contents__description" alignment={Alignment.CENTER}>
          {description}
        </Paragraph>
        {handleSearch && (
          <div className="hubHero__contents__search">
            <SearchBar name="hubSearch" placeholder={searchBarPlaceholder} onSubmit={(value) => handleSearch(value)} />
          </div>
        )}
        {tags && <TagsButtons tags={tags} selectedTag={selectedTag} />}
      </div>
    </LayoutSection>
  );
}

export default HubHero;
